export default __webpack_public_path__ + "gray_matter/hang_quote-ea1223eb24f6a342f4aeb94834c57fc9.svg";